'use client'

import { ReactNode } from 'react'
import { ThemeProvider } from '@/styles/theme.provider'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { config } from '@/config'
import AppNotification, { NotificationProvider } from '@/components/ui/Notification'
import { AuthProvider } from '@/components/auth/AuthProvider'
import { useServiceWorker } from '@/hooks/useServiceWorker'

interface Props {
  children: ReactNode
}

export function AppProviders({ children }: Props) {
  useServiceWorker()

  return (
    <AuthProvider>
      <GTMProvider state={{ id: config.gtmId }}>
        <ThemeProvider>
          <NotificationProvider>
            <AppNotification />
            {children}
          </NotificationProvider>
        </ThemeProvider>
      </GTMProvider>
    </AuthProvider>
  )
}
